import { environment } from './environment';

export const DataVariables = Object.freeze({

    ATTACHMENT_URL : environment.baseUrl + '/Attachment',
    APPLICATION_URL : environment.baseUrl+'/Application',
    DOCUMENTREF_URL : environment.baseUrl+'/DocumentRef',
    PAYMENT_URL : environment.baseUrl+'/Attachment/payment',
    PAYMENT_REFERRAL_URL  : environment.baseUrl+'/Attachment/PaymentRequest'
});

export const SubDataVariables = Object.freeze({

    ATTACHMENT_SINGLE_URL : DataVariables.ATTACHMENT_URL + '/Single',
    PAYMENT_ATTACMENT_URL: DataVariables.ATTACHMENT_URL + '/payment',
    CERTIFICATE_URL: DataVariables.ATTACHMENT_URL + '/Certificate',
    NOTIFICATION_URL: DataVariables.ATTACHMENT_URL + '/NotificationLetter',
    PREINSPECTION_QRCODE_URL : DataVariables.ATTACHMENT_URL + '/PreInspectionQRCode',
    POST_INSPECTION_QRCODE_URL : DataVariables.ATTACHMENT_URL + '/PostInspectionQRCode',
    INSPECTION_QRCODE_URL : DataVariables.ATTACHMENT_URL + '/InspectionQRCode',
    INSPECTION_LETTER_URL: DataVariables.ATTACHMENT_URL + '/InspectionLetter',
    GMP_CERTIFICATE_URL: DataVariables.ATTACHMENT_URL + '/GMPCertificate',
    INSPECTION_DOC_URL: DataVariables.ATTACHMENT_URL + '/Inspection',
    SYSTEM_FILE_URL: DataVariables.ATTACHMENT_URL + '/SystemFile',
    DEFICIENCY_LETTER_URL: DataVariables.ATTACHMENT_URL + '/DeficiencyLetter',
    NON_COMPLIANCE_LETTER_URL: DataVariables.ATTACHMENT_URL + '/NonComplianceLetter',
    COMPLIANCE_LETTER_URL: DataVariables.ATTACHMENT_URL + '/ComplianceLetter',

});

export const TypeVariables = Object.freeze({

    APPLICANT_TYPE_URL : environment.baseUrl +'/ApplicantType',
    PRODUCT_TYPE_URL : environment.baseUrl +'/ProductType/filter',
    FACILITY_TYPE_URL : environment.baseUrl +'/FacilityType',
    OWNERSHIP_TYPE_URL : environment.baseUrl +'/OrganizationType',
    M_LEVEL_URL : environment.baseUrl +'/MLevel',
    MR_LEVEL_URL :environment.baseUrl +'/MRLevel',
    EDUCATION_LEVEL_URL : environment.baseUrl +'/EducationLevel',
    PROFESSIONAL_TYPE_URL : environment.baseUrl +'/ProfessionalType',
    WOREDA_TYPE_URL : environment.baseUrl +'/Woreda',
    ZONE_TYPE_URL : environment.baseUrl +'/Zone',
    REGION_TYPE_URL : environment.baseUrl +'/Region'

})